module.exports = __webpack_public_path__ + "static/media/train.536d3fe6.svg";